module.exports = __webpack_public_path__ + "img/undead_23_nobg_.0011_720.90e3fd6b.png";